import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const Register = () => {
  const { t } = useTranslation();
  return (
    <Typography>
      {t(
        "Registration unavailable! Please contact your program administrator."
      )}
    </Typography>
  );
};
